import React from 'react';

// Containers
import ModalContainer from '../containers/ModalContainer';
import ChatInEligibleModalContainer from '../containers/ChatInEligibilityModalContainer';
import Notifier from '../containers/Notifier';
import ContactContainer from '../containers/ContactOptionsContainer';
import TopicTreeSwitch from '../containers/TopicTreeSwitch';
import ActiveArticle from '../containers/ActiveArticle';
import AlertsContainer from '../containers/Alerts';
import ErrorHandler from '../containers/ErrorHandler';
import EmailUs from '../containers/EmailUs';
import Page from '../../lib/page';
import ChatBotContainer from '../containers/ChatBotContainer';
import StepUpContainer from '../containers/StepUpContainer';
import UpfrontTracker from '../containers/UpfrontTracker';
import DisputeAlert from '../containers/DisputeAlert';
import NaaAlert from '../../common/NaaAlert';
import CovidBcpAlertContainer from '../containers/CovidBcpAlertContainer';
import CovidAlertModalContainer from '../containers/CovidAlertModalContainer';
import { disableTopicTree } from '../../lib/globalHelper';
import TrackerAlerts from '../../common/trackerAlerts';

const ContactUs = () => (
  <ErrorHandler>
    <div className="page-main-container">
      {Page.isLoggedIn() ? <NaaAlert pathName="contact-us" /> : <div />}
      {Page.isLoggedIn() ? <TrackerAlerts /> : <div />}
      <DisputeAlert />
      <AlertsContainer />
      {/* Disable topic tree when topictreedisabled remoteconfig is true or if the user is isC2MerchantMigrated */}
      {!disableTopicTree() && <TopicTreeSwitch />}
      <Notifier />
      <ModalContainer />
      <CovidBcpAlertContainer />
      <CovidAlertModalContainer />
      <ChatInEligibleModalContainer />
      {Page.isLoggedIn() ? <UpfrontTracker /> : null}
      <ActiveArticle />
      <ContactContainer />
      <EmailUs />
      <ChatBotContainer />
      <StepUpContainer />
    </div>
  </ErrorHandler>
);

export default ContactUs;
